module.exports = __webpack_public_path__ + "img/apple-icon-114x114.79e9229.png";